var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 248,
    viewBox: "0 0 249 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-134.272 123.472C-134.272 161.312 -126.245 191.355 -110.192 213.6C-93.9093 235.845 -68.6827 246.968 -34.512 246.968C-0.341328 246.968 24.8853 235.845 41.168 213.6C57.4507 191.355 65.592 161.312 65.592 123.472C65.592 85.8613 57.4507 55.9333 41.168 33.688C24.8853 11.4427 -0.341328 0.31999 -34.512 0.31999C-68.6827 0.31999 -93.9093 11.4427 -110.192 33.688C-126.245 55.704 -134.272 85.632 -134.272 123.472ZM-1.14399 123.472C-1.14399 142.507 -3.43733 157.184 -8.024 167.504C-12.3813 177.824 -21.2107 182.984 -34.512 182.984C-47.8133 182.984 -56.7573 177.824 -61.344 167.504C-65.7013 157.184 -67.88 142.507 -67.88 123.472C-67.88 104.667 -65.7013 90.104 -61.344 79.784C-56.7573 69.464 -47.8133 64.304 -34.512 64.304C-21.2107 64.304 -12.3813 69.464 -8.024 79.784C-3.43733 90.104 -1.14399 104.667 -1.14399 123.472ZM248.71 51.576L163.398 248H93.5662L179.91 59.832H84.2782V2.03999H248.71V51.576Z",
    fill: "#EAF0F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg07);
export default __webpack_public_path__ + "static/media/07.962256413bbf664f6dbc7285d16c7e2b.svg";
export { ForwardRef as ReactComponent };